import React from 'react';
import Icon from 'ui/Icon';
import request from 'utils/request_ajax';
import { isValidURL } from 'utils/string_utils';

class SubmitLinkTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      url: '',
      isSubmitted: false,
    };
  }

  submitLinkDemonstration = () => {
    request.post(`${window.location.pathname}/submissions.json`, {
      url: this.state.url,
    });
  };

  handleInputChange = e => {
    const { name } = e.target;
    let { value } = e.target;
    if (name === 'url') {
      value = value.replace(/\r?\n|\r/g, ' ');
    }
    this.setState({ [name]: value });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState(
      state => ({ isSubmitted: !state.isSubmitted }),
      this.submitLinkDemonstration,
    );
  };

  render() {
    const { path } = this.props;
    const { url, isSubmitted } = this.state;

    return (
      <div className="TabContainer">
        <div className="d-f fd-c ff-ss ai-c container">
          {!isSubmitted ? (
            <form onSubmit={this.handleSubmit} className="d-f fd-c ff-ss ai-c">
              <div className="lh-24 fz-18 pt-32 pb-32">
                {t('demonstrations.submit_link_instructions')}
              </div>
              <div className="SubmitLink d-f fd-r jc-sb ai-c">
                <input
                  id="url"
                  name="url"
                  className="SubmitLink-input NewInput NewInput--light"
                  placeholder={
                    'Enter a URL beginning with "http://" or "https://"'
                  }
                  type="url"
                  onChange={this.handleInputChange}
                  value={url}
                />
                <button
                  type="button"
                  disabled={!isValidURL(url)}
                  className="SubmitLink-button NewButton NewButton--lessonlyBrandColor NewButton--wide CustomColor--backgroundColor CustomColor--buttonBoxShadow h-36"
                  onClick={this.handleSubmit}
                >
                  {t('common.submit')}
                </button>
              </div>
            </form>
          ) : (
            <>
              <Icon
                name="demonstration-submission-rocket"
                className="SubmitLink-rocketIcon"
              />
              <span className="fw-b fz-18 lh-24 pt-32">
                {t('demonstrations.demonstration_submission_success_title')}
              </span>
              <span className="pt-16 fz-16 lh-24">
                {t('demonstrations.demonstration_submission_success_subtitle')}
              </span>
              <a
                href={`/path/${path.id}`}
                className="SubmitLink-backToCertificationNewButton NewButton--wide CustomColor--backgroundColor CustomColor--buttonBoxShadow h-36 mt-32 d-f ai-c "
              >
                <span>{t('demonstrations.back_to_certification')}</span>
              </a>
            </>
          )}
        </div>
      </div>
    );
  }
}

export default SubmitLinkTab;
